import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonDirectiveModule } from '../../../../directives/button-directive/button-directive.module';
import { DataSelectorDirective } from '../../../../directives/data-selector/data-selector.directive';
import { FileModel } from '../../../../models';
import { SharedModule } from '../../../../shared.module';

@Component({
  selector: 'app-unsupported-renderer',
  templateUrl: './unsupported-renderer.component.html',
  styleUrls: ['./unsupported-renderer.component.scss'],
  imports: [SharedModule, ButtonDirectiveModule, DataSelectorDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnsupportedRendererComponent {
  readonly file = input.required<Partial<FileModel>>();
  readonly canDownload = input<boolean>(true);

  readonly download = output<void>();

  protected onDownload(): void {
    this.download.emit();
  }
}
